    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <div class="page-title">
                        <h5>{{ 'shipping_options.details_title' | translate }}</h5>
                    </div>

                    <div *ngIf="loading" class="text-center py-5">
                        {{ 'common.loading' | translate }} ...
                    </div>

                    <div *ngIf="error && !loading" class="alert alert-danger">
                        {{ 'shipping_options.load_error' | translate }}
                    </div>

                    <div *ngIf="!loading && !error && optionDetail" class="shipping-detail-card">
                        <!-- Option Details Card -->
                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="mb-0">{{ 'shipping_options.details_title' | translate }}</h5>
                                <button class="btn-action btn-back" (click)="goBack()">
                                    <i class="fas fa-arrow-left"></i>
                                    {{ 'common.back' | translate }}
                                </button>
                            </div>
                            <div class="card-body">
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label class="form-label fw-bold">{{ 'shipping_options.select_shipping_type' |
                                            translate }}</label>
                                        <p class="form-control-plaintext">
                                            {{ optionDetail.shippingType?.description }}
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label fw-bold">{{ 'common.country' | translate }}</label>
                                        <p class="form-control-plaintext">
                                            {{ optionDetail.country?.name }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Add Pricing Button -->
                        <div class="mt-4 mb-4" *ngIf="!showPricingForm">
                            <button class="btn btn-primary" (click)="togglePricingForm()">
                                {{ 'shipping_pricing.add' | translate }}
                            </button>
                        </div>

                        <!-- Pricing Form Card -->
                        <div class="card pricing-form-card" *ngIf="showPricingForm">
                            <div class="card-header">
                                <h5 *ngIf="!isEditingPricing">{{ 'shipping_pricing.add' | translate }}</h5>
                                <h5 *ngIf="isEditingPricing">{{ 'shipping_pricing.edit' | translate }}</h5>
                            </div>
                            <div class="card-body">
                                <form [formGroup]="pricingForm" (ngSubmit)="onPricingSubmit()">
                                    <!-- Product Condition (First) -->
                                    <div class="mb-3">
                                        <label for="productConditionId" class="form-label">
                                            {{ 'shipping_pricing.product_condition' | translate }}
                                        </label>
                                        <select id="productConditionId" class="form-control"
                                            formControlName="productConditionId"
                                            [ngClass]="{ 'is-invalid': pricingForm.get('productConditionId')?.invalid && pricingForm.get('productConditionId')?.touched }">
                                            <option value="">{{ 'common.select' | translate }}</option>
                                            <option *ngFor="let condition of productConditions" [value]="condition.id">
                                                {{ condition.description }}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback"
                                            *ngIf="pricingForm.get('productConditionId')?.invalid && pricingForm.get('productConditionId')?.touched">
                                            {{ 'shipping_pricing.product_condition_required' | translate }}
                                        </div>
                                    </div>

                                    <!-- InterCity/IntraCity: Weight Fields (Second) -->
                                    <div class="row" *ngIf="isInterCity || isIntraCity">
                                        <div class="col-md-6 mb-3">
                                            <label for="weightMin" class="form-label">
                                                {{ 'shipping_pricing.weight_min' | translate }}
                                            </label>
                                            <input type="number" id="weightMin" class="form-control"
                                                formControlName="weightMin" />
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label for="weightMax" class="form-label">
                                                {{ 'shipping_pricing.weight_max' | translate }}
                                            </label>
                                            <input type="number" id="weightMax" class="form-control"
                                                formControlName="weightMax" />
                                        </div>
                                    </div>

                                    <!-- IntraCity: Distance Fields (Third) -->
                                    <div class="row" *ngIf="isIntraCity">
                                        <div class="col-md-6 mb-3">
                                            <label for="distanceMin" class="form-label">
                                                {{ 'shipping_pricing.distance_min' | translate }}
                                            </label>
                                            <input type="number" id="distanceMin" class="form-control"
                                                formControlName="distanceMin" />
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label for="distanceMax" class="form-label">
                                                {{ 'shipping_pricing.distance_max' | translate }}
                                            </label>
                                            <input type="number" id="distanceMax" class="form-control"
                                                formControlName="distanceMax" />
                                        </div>
                                    </div>

                                    <!-- Price + ETA (Fourth) -->
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label for="price" class="form-label">
                                                {{ 'shipping_pricing.price' | translate }}
                                            </label>
                                            <input type="number" id="price" class="form-control" formControlName="price"
                                                [ngClass]="{ 'is-invalid': pricingForm.get('price')?.invalid && pricingForm.get('price')?.touched }" />
                                            <div class="invalid-feedback"
                                                *ngIf="pricingForm.get('price')?.invalid && pricingForm.get('price')?.touched">
                                                {{ 'shipping_pricing.price_required' | translate }}
                                            </div>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <label for="eta" class="form-label">
                                                {{ 'shipping_pricing.eta' | translate }}
                                            </label>
                                            <input type="number" id="eta" class="form-control" formControlName="eta"
                                                [ngClass]="{ 'is-invalid': pricingForm.get('eta')?.invalid && pricingForm.get('eta')?.touched }" />
                                            <div class="invalid-feedback"
                                                *ngIf="pricingForm.get('eta')?.invalid && pricingForm.get('eta')?.touched">
                                                {{ 'shipping_pricing.eta_required' | translate }}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Packaging Details (Fifth) -->
                                    <div class="mb-3">
                                        <label for="packagingDetails" class="form-label">
                                            {{ 'shipping_pricing.packaging_details' | translate }}
                                        </label>
                                        <textarea id="packagingDetails" class="form-control" rows="3"
                                            formControlName="packagingDetails"
                                            [ngClass]="{ 'is-invalid': pricingForm.get('packagingDetails')?.invalid && pricingForm.get('packagingDetails')?.touched }"></textarea>
                                        <div class="invalid-feedback"
                                            *ngIf="pricingForm.get('packagingDetails')?.invalid && pricingForm.get('packagingDetails')?.touched">
                                            {{ 'shipping_pricing.packaging_details_required' | translate }}
                                        </div>
                                    </div>

                                    <!-- International: All Countries -->
                                    <div class="mb-3" *ngIf="!isInterCity && !isIntraCity">
                                        <div class="form-check">
                                            <input type="checkbox" id="allCountries" class="form-check-input"
                                                [checked]="allCountries" (change)="toggleAllCountries()" />
                                            <label class="form-check-label" for="allCountries">
                                                {{ 'shipping_pricing.all_countries' | translate }}
                                            </label>
                                        </div>
                                    </div>

                                    <div class="mb-3" *ngIf="!isInterCity && !isIntraCity && !allCountries">
                                        <label class="form-label">
                                            {{ 'shipping_pricing.select_countries' | translate }}
                                        </label>
                                        <div class="d-flex align-items-center gap-2 mb-2">
                                            <button type="button" class="btn btn-outline-success btn-sm"
                                                (click)="openCountryModal()">
                                                <i class="fas fa-edit me-1"></i>
                                                {{ 'shipping_pricing.modify_selection' | translate }}
                                            </button>
                                            <span class="text-muted small" *ngIf="getSelectedCountries().length > 0">
                                                {{ getSelectedCountries().length }} {{ 'shipping_pricing.selected' | translate }}
                                            </span>
                                        </div>
                                        <div class="chip-container">
                                            <span class="chip" *ngFor="let country of getSelectedCountries()">
                                                {{ country.name }}
                                                <button type="button" class="chip-remove" (click)="removeCountry(country.id)">
                                                    &times;
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <!-- InterCity/IntraCity: All Cities -->
                                    <div class="mb-3" *ngIf="isInterCity || isIntraCity">
                                        <div class="form-check">
                                            <input type="checkbox" id="allCities" class="form-check-input"
                                                [checked]="allCities" (change)="toggleAllCities()" />
                                            <label class="form-check-label" for="allCities">
                                                {{ 'shipping_pricing.all_cities' | translate }}
                                            </label>
                                        </div>
                                    </div>

                                    <div class="mb-3" *ngIf="(isInterCity || isIntraCity) && !allCities">
                                        <label class="form-label">
                                            {{ 'shipping_pricing.select_cities' | translate }}
                                        </label>
                                        <div class="d-flex align-items-center gap-2 mb-2">
                                            <button type="button" class="btn btn-outline-success btn-sm"
                                                (click)="openCityModal()">
                                                <i class="fas fa-edit me-1"></i>
                                                {{ 'shipping_pricing.modify_selection' | translate }}
                                            </button>
                                            <span class="text-muted small" *ngIf="getSelectedCities().length > 0">
                                                {{ getSelectedCities().length }} {{ 'shipping_pricing.selected' | translate }}
                                            </span>
                                        </div>
                                        <div class="chip-container">
                                            <span class="chip" *ngFor="let city of getSelectedCities()">
                                                {{ city.cityName }}
                                                <button type="button" class="chip-remove" (click)="removeCity(city.id)">
                                                    &times;
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-2">
                                        <button type="submit" class="btn btn-success"
                                            [disabled]="pricingForm.invalid || submittingPricing">
                                            <span *ngIf="!submittingPricing && !isEditingPricing">{{ 'common.submit' |
                                                translate }}</span>
                                            <span *ngIf="!submittingPricing && isEditingPricing">{{
                                                'shipping_pricing.update' | translate }}</span>
                                            <span *ngIf="submittingPricing">{{ 'common.loading' | translate }} ...</span>
                                        </button>
                                        <button type="button" class="btn btn-secondary"
                                            (click)="isEditingPricing ? cancelPricingEdit() : togglePricingForm()">
                                            {{ 'common.cancel' | translate }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <!-- Shipping Pricings List -->
                        <div class="card mt-4" *ngIf="!showPricingForm">
                            <div class="card-header">
                                <h5>{{ 'shipping_pricing.list_title' | translate }}</h5>
                            </div>
                            <div class="card-body">
                                <div *ngIf="loadingPricings" class="text-center py-4">
                                    {{ 'common.loading' | translate }} ...
                                </div>
                                <div *ngIf="!loadingPricings && shippingPricings.length === 0" class="empty-state">
                                    <p class="text-muted">{{ 'shipping_pricing.no_pricings' | translate }}</p>
                                </div>
                                <div *ngIf="!loadingPricings && shippingPricings.length > 0" class="table-responsive">
                                    <table class="table table-striped shipping-pricing-table">
                                        <thead>
                                            <tr>
                                                <th>Description</th>
                                                <th *ngIf="!isInterCity && !isIntraCity">{{
                                                    'shipping_pricing.all_countries_label' | translate }}</th>
                                                <th *ngIf="isInterCity || isIntraCity">{{ 'shipping_pricing.all_cities' |
                                                    translate }}</th>
                                                <th>{{ 'shipping_options.actions' | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let pricing of shippingPricings">
                                                <td>
                                                    Product Condition: {{ pricing.productCondition?.description }} <br />
                                                    Price: {{ pricing.price | number }} F <span
                                                        *ngIf="!isInterCity && !isIntraCity">/ KG</span> <br />
                                                    Estimate time for arrival: {{ pricing.eta }} {{ 'shipping_pricing.days'
                                                    | translate }} <br />
                                                    <span *ngIf="isInterCity || isIntraCity">
                                                        Weight: {{ pricing.weightMin }} - {{ pricing.weightMax }} (kg)<br />
                                                    </span>
                                                    <span *ngIf="isIntraCity">
                                                        Distance: {{ pricing.distanceMin }} - {{ pricing.distanceMax }}
                                                        (km)
                                                        <br />
                                                    </span>
                                                </td>
                                                <td *ngIf="!isInterCity && !isIntraCity">
                                                    <span *ngIf="pricing.allCountries">{{ 'common.yes' | translate }}</span>
                                                    <span *ngIf="!pricing.allCountries">{{ 'common.no' | translate }}</span>
                                                </td>
                                                <td *ngIf="isInterCity || isIntraCity">
                                                    <span *ngIf="pricing.allCities">{{ 'common.yes' | translate }}</span>
                                                    <span *ngIf="!pricing.allCities">{{ 'common.no' | translate }}</span>
                                                </td>
                                                <td>
                                                    <button class="me-2 btn-action" (click)="viewPricingDetail(pricing)"
                                                        title="{{ 'shipping_pricing.view_details' | translate }}">
                                                        <i class="fa fa-eye fa-view-link"></i>
                                                    </button>
                                                    <button class="me-2 btn-action" (click)="editPricing(pricing)"
                                                        title="{{ 'common.edit' | translate }}">
                                                        <i class="fa fa-edit fa-edit-link"></i>
                                                    </button>
                                                    <button class=" btn-action" (click)="confirmDeletePricing(pricing)"
                                                        title="{{ 'common.delete' | translate }}">
                                                        <i class="fa fa-trash fa-delete-link"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <app-sidebar [currentUser]="user"></app-sidebar>
                </div>
            </div>
        </div>
    </div>

    <!-- Pricing Detail Modal -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showPricingDetail }" *ngIf="showPricingDetail">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ 'shipping_pricing.view_details' | translate }}</h5>
                    <button type="button" class="btn-close" (click)="closePricingDetail()"></button>
                </div>
                <div class="modal-body" *ngIf="selectedPricing">
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.price' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.price | number }}</p>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.eta' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.eta }} {{ 'shipping_pricing.days' |
                                translate }}</p>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.product_condition' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.productCondition?.description }}</p>
                        </div>
                        <div class="col-md-6" *ngIf="!isInterCity && !isIntraCity">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.all_countries_label' | translate
                                }}</label>
                            <p class="form-control-plaintext">
                                <span *ngIf="selectedPricing.allCountries">{{ 'common.yes' | translate }}</span>
                                <span *ngIf="!selectedPricing.allCountries">{{ 'common.no' | translate }}</span>
                            </p>
                        </div>
                        <div class="col-md-6" *ngIf="isInterCity || isIntraCity">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.all_cities' | translate }}</label>
                            <p class="form-control-plaintext">
                                <span *ngIf="selectedPricing.allCities">{{ 'common.yes' | translate }}</span>
                                <span *ngIf="!selectedPricing.allCities">{{ 'common.no' | translate }}</span>
                            </p>
                        </div>
                    </div>
                    <!-- InterCity/IntraCity: Weight -->
                    <div class="row mb-3" *ngIf="isInterCity || isIntraCity">
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.weight_min' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.weightMin }}</p>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.weight_max' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.weightMax }}</p>
                        </div>
                    </div>
                    <!-- IntraCity: Distance -->
                    <div class="row mb-3" *ngIf="isIntraCity">
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.distance_min' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.distanceMin }}</p>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold">{{ 'shipping_pricing.distance_max' | translate }}</label>
                            <p class="form-control-plaintext">{{ selectedPricing.distanceMax }}</p>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">{{ 'shipping_pricing.packaging_details' | translate }}</label>
                        <p class="form-control-plaintext">{{ selectedPricing.packagingDetails }}</p>
                    </div>
                    <div class="mb-3"
                        *ngIf="!isInterCity && !isIntraCity && !selectedPricing.allCountries && selectedPricing.countries?.length > 0">
                        <label class="form-label fw-bold">{{ 'shipping_pricing.countries_label' | translate }}</label>
                        <div class="form-control-plaintext">
                            <span *ngFor="let country of selectedPricing.countries; let last = last">
                                {{ country.name }}<span *ngIf="!last">, </span>
                            </span>
                        </div>
                    </div>
                    <div class="mb-3"
                        *ngIf="(isInterCity || isIntraCity) && !selectedPricing.allCities && selectedPricing.cities?.length > 0">
                        <label class="form-label fw-bold">{{ 'shipping_pricing.cities_label' | translate }}</label>
                        <div class="form-control-plaintext">
                            <span *ngFor="let city of selectedPricing.cities; let last = last">
                                {{ city.cityName }}<span *ngIf="!last">, </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closePricingDetail()">
                        {{ 'common.close' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showPricingDetail"></div>

    <!-- Delete Pricing Confirmation Modal -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showDeletePricingModal }"
        *ngIf="showDeletePricingModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ 'shipping_pricing.delete_confirm_title' | translate }}</h5>
                    <button type="button" class="btn-close" (click)="closeDeletePricingModal()"></button>
                </div>
                <div class="modal-body">
                    <p>{{ 'shipping_pricing.delete_confirm_message' | translate }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeDeletePricingModal()">
                        {{ 'common.cancel' | translate }}
                    </button>
                    <button type="button" class="btn btn-danger" (click)="deletePricing()">
                        {{ 'common.delete' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showDeletePricingModal"></div>

    <!-- Country Selection Modal -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showCountryModal }"
        *ngIf="showCountryModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ 'shipping_pricing.select_countries' | translate }}</h5>
                    <button type="button" class="btn-close" (click)="cancelCountrySelection()"></button>
                </div>
                <div class="modal-body">
                    <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="id"
                        [multiple]="true"
                        [searchable]="true"
                        [(ngModel)]="modalCountryIds"
                        [placeholder]="'shipping_pricing.search_countries' | translate">
                    </ng-select>

                    <div *ngIf="getModalCountries().length > 0" class="mt-3">
                        <label class="form-label small text-muted">
                            {{ 'shipping_pricing.selected_items' | translate }}
                        </label>
                        <div class="chip-container">
                            <span class="chip" *ngFor="let country of getModalCountries()">
                                {{ country.name }}
                                <button type="button" class="chip-remove" (click)="removeCountryFromModal(country.id)">
                                    &times;
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="cancelCountrySelection()">
                        {{ 'common.cancel' | translate }}
                    </button>
                    <button type="button" class="btn btn-success" (click)="confirmCountrySelection()">
                        {{ 'common.confirm' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showCountryModal"></div>

    <!-- City Selection Modal -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showCityModal }"
        *ngIf="showCityModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ 'shipping_pricing.select_cities' | translate }}</h5>
                    <button type="button" class="btn-close" (click)="cancelCitySelection()"></button>
                </div>
                <div class="modal-body">
                    <ng-select
                        [items]="cities"
                        bindLabel="cityName"
                        bindValue="id"
                        [multiple]="true"
                        [searchable]="true"
                        [(ngModel)]="modalCityIds"
                        [placeholder]="'shipping_pricing.search_cities' | translate">
                    </ng-select>

                    <div *ngIf="getModalCities().length > 0" class="mt-3">
                        <label class="form-label small text-muted">
                            {{ 'shipping_pricing.selected_items' | translate }}
                        </label>
                        <div class="chip-container">
                            <span class="chip" *ngFor="let city of getModalCities()">
                                {{ city.cityName }}
                                <button type="button" class="chip-remove" (click)="removeCityFromModal(city.id)">
                                    &times;
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="cancelCitySelection()">
                        {{ 'common.cancel' | translate }}
                    </button>
                    <button type="button" class="btn btn-success" (click)="confirmCitySelection()">
                        {{ 'common.confirm' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showCityModal"></div>